/* Infinote product page: instant colour switching.
   Clicking a family swatch fetches the sibling product page, swaps the page content in place, updates URL/title/meta, and
   re-initialises the theme's components (they start themselves when new elements connect). Any failure falls back to a normal page load. */
(() => {
  if (window.__infinoteSwitcher) return; window.__infinoteSwitcher = true;
  const container = () => document.getElementById('MainContent') || document.querySelector('main');
  let busy = false;

  const run = (root) => {                        // re-run inline classic scripts that the swap leaves inert
    root.querySelectorAll('script').forEach((old) => {
      const type = (old.getAttribute('type') || '').toLowerCase();
      if (type && type !== 'text/javascript' && type !== 'module') return;
      if (type === 'module' && !old.src) return;   // inline modules are left to the theme
      if (old.src) {
        const base = old.src.split('?')[0];
        if (![...document.scripts].some((x) => x.src && x.src.split('?')[0] === base)) { const s = document.createElement('script'); s.src = old.src; if (type === 'module') s.type = 'module'; else s.defer = true; document.head.appendChild(s); }
        return;
      }
      const s = document.createElement('script'); s.text = old.textContent; old.replaceWith(s);
    });
  };

  const swap = async (url, push) => {
    if (busy) return; busy = true;
    const main = container();
    try {
      main.classList.add('inf-switching');
      const res = await fetch(url, { headers: { 'X-Requested-With': 'infinote-switch' }, credentials: 'same-origin' });
      if (!res.ok) throw new Error('bad status');
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const next = doc.getElementById('MainContent') || doc.querySelector('main');
      if (!next || !next.querySelector('.infinote-family')) throw new Error('unexpected page');
      main.replaceChildren(...Array.from(next.childNodes).map((n) => document.importNode(n, true)));
      run(main);
      document.title = doc.title;
      ['meta[name="description"]', 'link[rel="canonical"]', 'meta[property="og:title"]', 'meta[property="og:description"]', 'meta[property="og:image"]', 'meta[property="og:url"]'].forEach((sel) => {
        const a = document.head.querySelector(sel), b = doc.head.querySelector(sel);
        if (a && b) a.replaceWith(b.cloneNode(true));
      });
      if (push) history.pushState({ inf: 1 }, '', url);
      window.scrollTo({ top: 0, behavior: 'auto' });
      document.dispatchEvent(new CustomEvent('infinote:product-switched', { detail: { url } }));
      document.dispatchEvent(new Event('shopify:section:load'));
    } catch (e) {
      window.location.href = url; return;
    } finally {
      main.classList.remove('inf-switching'); busy = false;
    }
  };

  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a.infinote-family__swatch');
    if (!a || a.classList.contains('is-selected')) { if (a) e.preventDefault(); return; }
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault(); swap(a.href, true);
  });
  window.addEventListener('popstate', (e) => { if (e.state && e.state.inf) swap(location.href, false); });
  history.replaceState({ inf: 1 }, '', location.href);

  // warm the cache when someone hovers a swatch
  document.addEventListener('pointerover', (e) => {
    const a = e.target.closest && e.target.closest('a.infinote-family__swatch');
    if (!a || a.dataset.warm) return; a.dataset.warm = '1';
    const l = document.createElement('link'); l.rel = 'prefetch'; l.href = a.href; l.as = 'document'; document.head.appendChild(l);
  }, { passive: true });

  /* Option coupling: choosing a value that does not exist with the other current choices moves the other options to the closest real variant
     (e.g. Size B6 exists only with 128 pages, so picking B6 switches Pages to 128). Runs before the theme reads the selection. */
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t || t.type !== 'radio' || !t.closest('.product-detail__variant-picker')) return;
    const pj = document.querySelector('script.productJson'); if (!pj) return;
    let data; try { data = JSON.parse(pj.textContent); } catch (_) { return; }
    const picker = t.closest('.product-detail__variant-picker');
    const radios = [...picker.querySelectorAll('input[type="radio"]')];
    const names = [...new Set(radios.map((r) => r.name))];
    const idx = names.indexOf(t.name); if (idx < 0) return;
    const chosen = names.map((n) => (radios.find((r) => r.name === n && r.checked) || {}).value);
    chosen[idx] = t.value;
    const opt = (v, i) => v['option' + (i + 1)];
    const exact = data.variants.find((v) => names.every((_, i) => opt(v, i) === chosen[i]));
    if (exact) return;                                             // valid combination: nothing to do
    const score = (v) => names.reduce((n, _, i) => n + (opt(v, i) === chosen[i] ? 1 : 0), 0);
    const candidates = data.variants.filter((v) => opt(v, idx) === t.value).sort((a, b) => (b.available - a.available) || (score(b) - score(a)));
    const best = candidates[0]; if (!best) return;
    names.forEach((n, i) => {
      if (i === idx) return;
      const r = radios.find((x) => x.name === n && x.value === opt(best, i));
      if (r) r.checked = true;
    });
  }, true);

  /* Keep the Details accordion in step with the selected variant: re-render just that block through the Section Rendering API. */
  let detailsTimer = null;
  const refreshDetails = async () => {
    const wrap = document.querySelector('.infinote-accordions'); if (!wrap) return;
    const section = wrap.closest('[id^="shopify-section-"]'); if (!section) return;
    const variant = new URLSearchParams(location.search).get('variant'); if (!variant) return;
    try {
      const res = await fetch(`${location.pathname}?variant=${variant}&section_id=${section.id.replace('shopify-section-', '')}`);
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = doc.querySelector('.infinote-spec-list'), cur = wrap.querySelector('.infinote-spec-list');
      if (fresh && cur) cur.replaceWith(fresh);
    } catch (_) { /* leave the current details in place */ }
  };
  document.addEventListener('change', (e) => {
    if (!e.target || e.target.type !== 'radio' || !e.target.closest('.product-detail__variant-picker')) return;
    clearTimeout(detailsTimer); detailsTimer = setTimeout(refreshDetails, 700);
  });

  /* Reviews: "Load more reviews" reveals the next batch. */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('[data-inf-more]'); if (!btn) return;
    const root = btn.closest('[data-inf-reviews]'); const batch = parseInt(btn.dataset.batch, 10) || 5;
    const hidden = [...root.querySelectorAll('[data-inf-extra][hidden]')];
    hidden.slice(0, batch).forEach((li) => li.removeAttribute('hidden'));
    if (hidden.length <= batch) btn.remove();
  });
  /* Options with nothing to choose are hidden: Size when the product has one size, Pages when the chosen size has one page count
     (page count lives in Specifications). Real choices stay visible. The descriptor under the name follows the selected variant's dimensions. */
  const tidyOptions = () => {
    const pj = document.querySelector('script.productJson'), picker = document.querySelector('.product-detail__variant-picker');
    if (!pj || !picker) return;
    let data; try { data = JSON.parse(pj.textContent); } catch (_) { return; }
    const sets = [...picker.querySelectorAll('fieldset')];
    const names = sets.map((f) => { const r = f.querySelector('input[type="radio"]'); return r && r.name; });
    const picked = sets.map((f) => { const r = f.querySelector('input:checked'); return r && r.value; });
    const opt = (v, i) => v['option' + (i + 1)];
    sets.forEach((f, i) => {
      const pool = i === 0 ? data.variants : data.variants.filter((v) => opt(v, 0) === picked[0]);
      f.classList.toggle('inf-opt-hidden', new Set(pool.map((v) => opt(v, i))).size <= 1);
    });
    const now = document.querySelector('.infinote-price__now'), note = document.querySelector('.infinote-price__note');
    const sel = data.variants.find((v) => names.every((_, i) => opt(v, i) === picked[i]));
    if (now && note && sel) {
      const fmt = (c) => '₹' + (c / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
      const n1 = fmt(sel.price), n2 = (sel.compare_at_price > sel.price ? 'MRP ' + fmt(sel.compare_at_price) + ' · ' : '') + (note.dataset.note || '');
      if (now.textContent !== n1) now.textContent = n1;
      if (note.textContent !== n2) note.textContent = n2;
    }
    const d = document.querySelector('[data-inf-descriptor]');
    if (d) {
      let dims = {}; try { dims = JSON.parse((document.querySelector('[data-inf-dims]') || {}).textContent || '{}'); } catch (_) {}
      const si = names.indexOf('Size'), tail = (sel && dims[sel.id]) || (si >= 0 && picked[si]) || '', t = d.dataset.base + (tail ? ' · ' + tail : '');
      if (d.textContent !== t) d.textContent = t;
    }
  };
  let tidyQueued = false;
  const queueTidy = () => { if (tidyQueued) return; tidyQueued = true; requestAnimationFrame(() => { tidyQueued = false; tidyOptions(); }); };
  document.addEventListener('change', (e) => { if (e.target && e.target.type === 'radio') setTimeout(queueTidy, 0); });
  document.addEventListener('infinote:product-switched', queueTidy);
  new MutationObserver(queueTidy).observe(document.body, { childList: true, subtree: true });
  if (document.readyState !== 'loading') queueTidy(); else document.addEventListener('DOMContentLoaded', queueTidy);
})();

/* Accordions: opening a row closes the others and scrolls just enough to reveal the whole opened row (no further), so the purchase
   controls above stay in view whenever possible. If the row is taller than the visible area its top is aligned instead.
   Desktop: only the self-scrolling purchase column moves (never the page). Mobile: the page, clear of the floating header.
   `toggle` does not bubble: capture it. */
document.addEventListener('toggle', (e) => {
  const d = e.target;
  if (!d || !d.matches || !d.matches('details.infinote-accordion') || !d.open) return;
  document.querySelectorAll('details.infinote-accordion[open]').forEach((o) => { if (o !== d) o.open = false; });
  const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const col = d.closest('.product-detail__information');
  const desktop = col && window.matchMedia('(min-width: 1024px)').matches;
  const view = desktop ? col.getBoundingClientRect() : { top: 96, bottom: window.innerHeight };   // visible band
  const r = d.getBoundingClientRect(), gap = 16;
  let delta = r.bottom > view.bottom - gap ? r.bottom - view.bottom + gap : 0;                      // reveal the bottom
  if (r.top - delta < view.top) delta = r.top - view.top;                                           // ...but never push the top out of view
  if (Math.abs(delta) < 1) return;
  if (desktop) col.scrollBy({ top: delta, behavior }); else window.scrollBy({ top: delta, behavior });
}, true);

/* The hero is sized to the viewport minus everything above it (announcement bar + floating header). Measure that instead of assuming it,
   and re-measure when the bar is closed, the header changes or the window is resized. */
(() => {
  const set = () => {
    const m = document.getElementById('MainContent'); if (!m) return;
    const top = m.getBoundingClientRect().top + window.scrollY + (parseFloat(getComputedStyle(m).paddingTop) || 0);   // the floating header is cleared by #MainContent's padding, so the hero starts below it
    document.documentElement.style.setProperty('--inf-chrome', Math.max(0, Math.round(top)) + 'px');
  };
  set(); window.addEventListener('resize', set); window.addEventListener('load', set);
  if (window.ResizeObserver) { const ro = new ResizeObserver(set); document.querySelectorAll('.shopify-section-group-header-group, announcement-bar').forEach((e) => ro.observe(e)); }
  document.addEventListener('infinote:product-switched', set);
})();
